const binding = {
  init: (element, valueAccessor) => {
    let ref = valueAccessor();
    ref.element(element);
  }
};

import { registerBinding } from 'Utils/engine/register-binding';
registerBinding('fbRef', binding);
